<template>
  <div>
    <Loader v-if="subscribed === 'PENDING'" />
    <Redirect v-if="subscribed === 'NO'" />
    <AppStore v-if="subscribed === 'YES'" />
  </div>
</template>

<script>
import { mapState } from "vuex";
import Loader from "@/components/UI/Loader.vue";
import Redirect from "@/views/Redirect.vue";
import AppStore from "@/components/Store/App.vue";

export default {
  name: "StoreHasEcommerceFeatureEnabled",
  components: { AppStore, Loader, Redirect },
  computed: {
    ...mapState({
      subscribed: state => state.store.subscribed
    })
  }
};
</script>
